module.exports = __webpack_public_path__ + "img/332.d413184c.jpg";